import { exitViewAs, getViewAsUserName, isViewingAs, isViewingAsTestUser } from "@/auth/viewAs";
import { Button, Group, Paper, Text } from "@mantine/core";

export function ViewAsBanner() {
  if (!isViewingAs()) {
    return null;
  }

  const userName = getViewAsUserName() || "사용자";
  const isTestUser = isViewingAsTestUser();
  const color = isTestUser ? "grape.7" : "red.7";
  const modeLabel = isTestUser ? "테스트 유저 · 변경 가능" : "보기 전용";

  return (
    <Paper
      bg={color}
      px="md"
      py={6}
      radius="xl"
      shadow="md"
      style={{
        position: "fixed",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10000,
      }}
    >
      <Group gap="sm" wrap="nowrap">
        <Text size="sm" fw={600} c="white" style={{ whiteSpace: "nowrap" }}>
          {userName}님으로 보는 중 ({modeLabel})
        </Text>
        <Button size="compact-xs" color="white" variant="white" c={color} onClick={exitViewAs}>
          종료
        </Button>
      </Group>
    </Paper>
  );
}
